module.exports = __webpack_public_path__ + "static/media/95.e0aea959.jpg";